import { Button, FormControl, Grid, OutlinedInput, Stack, styled, TextField, Typography } from '@mui/material'
import { Box } from '@mui/system'
import React from 'react'
import { customStyles } from '../../../styles'
import { BodyContainer } from '../../containers/BodyContainer'
import { LightText, MainButton, UnderlineText } from '../../helpers'
import { SecurityCodeForm } from './SecurityCodeForm'
import OtpInput from 'react18-input-otp';
import { useState } from 'react'
import logo from '../../../assets/images/logo.png'
import { animations } from '../../../utils/animations'
import { useDispatch, useSelector } from 'react-redux'
import { confirmAccount, loginAction, resendCodeAction } from '../../../actions/loginActions'
import { useEffect } from 'react'
import { Navigate, useNavigate } from 'react-router-dom'
import { useLocalStorage } from '../../../hooks/useLocalStorage'
import { cancelRegister } from '../../../slices/LoginSlice'

export const SecurityCode = () => {
  const [otp, setOtp] = useState('');
  const { register, user, phoneLogin, recieveCode,  logOrRegister} = useSelector(state => state.login)
  const { token } = useSelector(state => state.apiToken)
  const [ authorization, setValue ] = useLocalStorage('login-token', null)
  const navigate = useNavigate()
  const dispatch = useDispatch()
  const handleChange = (enteredOtp) => {
    setOtp(enteredOtp);
  };

  const handleSubmit = () => {
    if(otp.length === 5) {
      logOrRegister
      ? dispatch(loginAction({ 
        phone: register ? register.phone  : phoneLogin,
        method: 'sms',
        key: otp
      }))
      : dispatch(confirmAccount({ 
        phone: register ? register.phone  : phoneLogin, 
        identifier: "ABC124",
        code: otp }, token))
    }
  }

  const cancel = () => {
    dispatch(cancelRegister())
    navigate('/')
  }

  const handleResendCode = () => {
    dispatch(resendCodeAction(
      { 
        phone: register ? register.phone  : phoneLogin, 
        identifier: "ABC124"
      }, token)
    )
  }
  
  useEffect(() => {
    user && setValue(user)
    
  }, [user])

  useEffect(() => {
    user?.token && navigate('/dashboard/content', { replace: true })
  }, [user])
  return (

   <BodyContainer title="" className={animations.fadeIn}>
      <figure style={{ display: 'flex', justifyContent: 'center', marginBottom: 30 }}>
        <img src={logo} alt="global gas" className={animations.fadeBottom} style={{
          width: '200px'
        }}/>
      </figure>
      <Stack  alignItems="center" spacing={3}>
        <Typography mb={3} variant="h5" component="h2" textAlign="center" style={{
          fontWeight: 700
        }}>Inicia sesión</Typography>
        {/* <SecurityCodeForm /> */}
        <OtpInput isInputSecure value={otp} onChange={handleChange} numInputs={5} separator={<span>-</span>} inputStyle={{ width: 50, height: 50, borderRadius: 5, border: `1px solid ${customStyles.colors.secondary}` }} /> 
        {/* <Button text="" onClick={handleResendCode}/> */}
        <Button onClick={handleResendCode}>¿No recibiste el código? Te lo reenviamos</Button>
        <Stack direction="row" justifyContent="space-between" spacing={3}>
          <MainButton text="Cancelar" variant="outlined" color="error" onClick={cancel}/>
          <MainButton text="Siguiente" variant="contained" onClick={handleSubmit}/>
        </Stack>
        <LightText text="El SMS puede tardar en llegar hasta un minuto, esto depende de tu compañia telefónica"/>
      </Stack>
    </BodyContainer>
  
  )
}
